import { TaskDuration } from 'aos-services/src/services/tasks/types/TaskStatus'
import { Box, Input, InputField } from 'aos-ui-universal'
import { clamp } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface TaskDurationFieldProps {
    value?: TaskDuration
    onChange(v: TaskDuration): void
}

const parseBounded = (raw: string, max: number) => clamp(parseInt(raw, 10) || 0, 0, max)

export const TaskDurationField = ({ value, onChange }: TaskDurationFieldProps) => {
    const { t } = useTranslation()

    return (
        <Box className='flex-row gap-3'>
            <Input className='flex-1'>
                <InputField
                    keyboardType='numeric'
                    placeholder={t('time-picker.hours', { ns: 'tasks' })}
                    value={value ? String(value.hour) : ''}
                    onChangeText={(v: string) =>
                        onChange({ minute: value?.minute ?? 0, hour: parseBounded(v, 999) })
                    }
                />
            </Input>
            <Input className='flex-1'>
                <InputField
                    keyboardType='numeric'
                    placeholder={t('time-picker.minutes', { ns: 'tasks' })}
                    value={value ? String(value.minute) : ''}
                    onChangeText={(v: string) =>
                        onChange({ hour: value?.hour ?? 0, minute: parseBounded(v, 59) })
                    }
                />
            </Input>
        </Box>
    )
}
